import React, { createContext, useContext, useState, ReactNode } from 'react'
import { SessionInfo } from '../models/SessionInfo'
const SessionContext = createContext<SessionContextType | undefined>(undefined)

export const ActiveSessionProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [session, setSession] = useState<SessionInfo | null>(null)

  return (
    <SessionContext.Provider value={{ session, setSession }}>
      {children}
    </SessionContext.Provider>
  )
}

export const useSessionInfo = (): SessionContextType => {
  const context = useContext(SessionContext)
  if (context === undefined) {
    throw new Error(
      'useSessionInfo must be used within a ActiveSessionProvider',
    )
  }
  return context
}

interface SessionContextType {
  session: SessionInfo | null
  setSession: (session: SessionInfo | null) => void
}
